'use client';
import React from 'react';
import { WalletProvider } from '@/wallet';

import SwapContent from './components/SwapContent';

export default function SwapPage() {
  return (
    <WalletProvider>
      <SwapContent />
    </WalletProvider>
  );
}
